import {
	FETCH_MATTER_DETAIL_REQUEST,
	FETCH_MATTER_DETAIL_SUCCESS,
	FETCH_MATTER_DETAIL_FAILURE,
	FETCH_MATTERS_LIST_REQUEST,
	FETCH_MATTERS_LIST_SUCCESS,
	FETCH_MATTERS_LIST_FAILURE,
	GET_EVERYTHING_FOR_NEW_EDIT_MATTER_REQUEST,
	GET_EVERYTHING_FOR_NEW_MATTER_SUCCESS,
	GET_EVERYTHING_FOR_NEW_MATTER_FAILURE,
	GET_EVERYTHING_FOR_EDIT_MATTER_SUCCESS,
	GET_EVERYTHING_FOR_EDIT_MATTER_FAILURE,
	CREATE_NEW_MATTER_REQUEST,
	CREATE_NEW_MATTER_SUCCESS,
	CREATE_NEW_MATTER_FAILURE,
	UNMOUNT_NEW_EDIT_MATTER,
	SET_SUBHEADER_TEXT,
	SET_EDIT_MATTER_REDIRECT_LOCATION,
	CLOSE_GLOBAL_EDIT_DIALOG,
	OPEN_GLOBAL_SNACKBAR,
	CLOSE_GLOBAL_SNACKBAR,
	UNSELECT_ALL,
} from "./types";
import React from "react";
import { beginBulkDownloadJob } from "./jobProgressActions";
import {
	NORMAL_LIFECYCLE_STATUS,
	TRASH_LIFECYCLE_STATUS,
	ARCHIVE_LIFECYCLE_STATUS,
} from "../utilities/lifecycleStatus";

import { setGlobalSearchMatterIDs } from "./globalSearchbarActions";
import { updateRecentlyViewedMatters } from "./browserLocalstorageActions";

import store from "../store";

import API from "../utilities/LocalApiProxy";
import { openGlobalDialog } from "./globalEditDialogActions";
import { numberWithCommas } from "../utilities/utilities";
import {
	isPreventActionOnDeletedResource,
	isPreventArchiveAction,
	isRateLimitError,
} from "./errorActions";
import { listTrash } from "./trashActions";

function matterDataHelper(matterData) {
	const {
		name,
		matterID,
		customMatterID,
		description,
		client,
		matterType,
		officeBranch,
		assignedStaff,
		matterTags,
		dateOpened,
		dateClosed,
		needAccessToMatter,
		matterPermissions,
	} = matterData;

	const newMatterData = {
		name,
		matterID,
		customMatterID,
		description,
		client,
		matterType,
		officeBranch,
		assignedStaff,
		matterTags,
		dateOpened,
		dateClosed,
		needAccessToMatter,
	};

	if (matterPermissions) {
		const { matterPermissionGlobalSetting, userAllowList, groupAllowList } =
			matterPermissions;
		newMatterData.matterPermissions = {
			matterPermissionGlobalSetting,
			userAllowList,
			groupAllowList,
		};
	}

	newMatterData.matterTags = matterTags
		? matterTags.map((tag) => tag.label)
		: [];
	newMatterData.assignedStaff = assignedStaff
		? assignedStaff.map(
				//.value is the id of the user.  Should this be the sub?
				(atty) => atty.value
			)
		: [];

	if (client) {
		if (client.__isNew__) {
			newMatterData.newClientName = client.value;
		} else {
			newMatterData.existingClientID = client.clientID;
		}
	} else {
		newMatterData.existingClientID = null;
	}
	if (matterType) {
		if (matterType.__isNew__) {
			newMatterData.newMatterTypeName = matterType.value;
		} else {
			newMatterData.existingMatterTypeID = matterType.matterTypeID;
		}
	} else {
		newMatterData.existingMatterTypeID = null;
	}
	if (officeBranch) {
		if (officeBranch.__isNew__) {
			newMatterData.newOfficeBranchName = officeBranch.value;
		} else {
			newMatterData.existingOfficeBranchID = officeBranch.officeBranchID;
		}
	} else {
		newMatterData.existingOfficeBranchID = null;
	}
	newMatterData.dateOpened = dateOpened ? dateOpened : null;
	newMatterData.dateClosed = dateClosed ? dateClosed : null;
	return newMatterData;
}
export function createNewMatter(matterData) {
	matterData.name = matterData.name.trim();
	const newMatterData = matterDataHelper(matterData);
	return function (dispatch) {
		dispatch({ type: CREATE_NEW_MATTER_REQUEST });
		API.post("/matters/new", {
			body: { newMatterData: newMatterData },
		})
			.then((results) => {
				window.globalHistory.push(
					`/matters/${results.mysql.newMatterID}/docs/`
				);
				dispatch({ type: CREATE_NEW_MATTER_SUCCESS });
				if (results.mysql?.updateMatterPermissionsDenied === true) {
					// user attempted to add matter permissions but backend claims they don't have the right
					dispatch({
						type: OPEN_GLOBAL_SNACKBAR,
						payload: {
							variant: "warning",
							message:
								"Matter created, but matter permissions were not applied.",
						},
					});
				}
			})
			.catch(() => {
				dispatch({ type: CREATE_NEW_MATTER_FAILURE });
			});
	};
}
export function openBulkMatterPermissionsDialog({ allMatters, clientName }) {
	return function (dispatch, getState) {
		function submitBulkMatterPermissionsDialog(state) {
			// submit function
			const matterPermissionsOutputObject =
				state.matterPermissionsOutputObject;
			// matterPermissionsOutputObject example: {
			// 	matterPermissionGlobalSetting: "allUsers" || "specifiedUsers",
			// 	userAllowList:
			// 		this.state.userAllowList && !setToAllUsers
			// 			? this.state.userAllowList.map((u) => ({
			// 					userSub: u.value,
			// 					type: "ALLOW_READ_WRITE",
			// 				}))
			// 			: [],
			// 	groupAllowList:
			// 		this.state.groupAllowList && !setToAllUsers
			// 			? this.state.groupAllowList.map((g) => ({
			// 					groupID: g.value,
			// 					type: "ALLOW_READ_WRITE",
			// 				}))
			// 			: [],
			// 	matterIDsToApplyPermissionsTo: []<matterIDs>,
			// 	ignoreMattersThatAlreadyHavePermissions: boolean,
			// 	confirmed: this.state.confirmBox === "confirm",
			// 	allMatchingMatterIDsWithPermissions: []<matterIDs>,
			// };
			if (matterPermissionsOutputObject) {
				const requestBody = {};
				if (
					matterPermissionsOutputObject.matterPermissionGlobalSetting ===
					"specifiedUsers"
				) {
					requestBody.userAllowList =
						matterPermissionsOutputObject.userAllowList;
					requestBody.groupAllowList =
						matterPermissionsOutputObject.groupAllowList;
					requestBody.onlyDeleteExistingPermissions = false;
				}

				if (
					matterPermissionsOutputObject.matterPermissionGlobalSetting ===
					"allUsers"
				) {
					requestBody.onlyDeleteExistingPermissions = true;
				}

				if (
					matterPermissionsOutputObject.ignoreMattersThatAlreadyHavePermissions
				) {
					requestBody.matterIDs =
						matterPermissionsOutputObject.matterIDsToApplyPermissionsTo.filter(
							(val) =>
								!matterPermissionsOutputObject.allMatchingMatterIDsWithPermissions.includes(
									val
								)
						);
				} else {
					requestBody.matterIDs =
						matterPermissionsOutputObject.matterIDsToApplyPermissionsTo;
				}

				// show a snackbar with a loading spinner
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "info",
						message: `Updating permissions for ${numberWithCommas(requestBody.matterIDs.length)} matters`,
						loadingSpinnerVisible: true,
					},
				});

				API.post("/bulk/matter/permissions/apply", {
					body: { ...requestBody },
				})
					.then((res) => {
						dispatch({
							type: OPEN_GLOBAL_SNACKBAR,
							payload: {
								variant: "success",
								message: `Permissions updated for ${numberWithCommas(res.mysql.numMattersUpdated)} matters`,
							},
						});
					})
					.catch((err) => {
						console.error(err);
						if (
							isPreventActionOnDeletedResource(err.lxwErrorCode)
						) {
							// handled in errorActions
							return;
						}
						dispatch({
							type: OPEN_GLOBAL_SNACKBAR,
							payload: {
								variant: "error",
								message:
									"Unable to process this request. Please contact support for assistance.",
							},
						});
					});
			} else {
				console.error("no matterPermissionsOutputObject");

				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "error",
						message:
							"Unable to process this request. Please contact support for assistance.",
					},
				});
			}
			dispatch({
				type: CLOSE_GLOBAL_EDIT_DIALOG,
			});
		}

		function validateBulkMatterPermissionsDialog(state) {
			// validate function
			if (
				state.matterPermissionsOutputObject.confirmed &&
				state.matterPermissionsOutputObject
					.numMatterPermissionsToBeUpdated > 0
			) {
				return { canSubmit: true };
			} else {
				return {
					canSubmit: false,
					disabledHoverTextForSubmitButton: !state
						.matterPermissionsOutputObject.confirmed
						? '"confirm" must be typed into the box above'
						: "No matters to update",
				};
			}
		}

		// when creating this, accessing the filteredCount and filteredMatterIDs in the MattersList component was detrimental to performance, sometimes crashing the app
		// to get around that problem, we will access the data we need from the state here
		const { globalSearchbar } = getState();
		const matterIDsToApplyPermissionsTo = globalSearchbar
			? globalSearchbar.allVisibleMatterIDsOnScreen
			: [];

		const numMattersToApplyPermissionsTo =
			matterIDsToApplyPermissionsTo.length;

		if (numMattersToApplyPermissionsTo > 0) {
			// open global dialog with a loading spinner and title
			openGlobalDialog(
				{
					label: `Bulk Update Matter Permissions`,
					canSubmit: false,
					disabledHoverTextForSubmitButton:
						'"confirm" must be typed into the box above',
					hideTextfield: true,
					type: "BulkMatterPermissions",
					submitButtonLabel: "Apply",
					readOnly: false,
					extraCSSClass: "WideEditDialog",
					bulkMatterPermissionsObject: {
						loading: true,
						matterIDsToApplyPermissionsTo,
						numFilteredMattersString: numberWithCommas(
							numMattersToApplyPermissionsTo
						),

						numAllMattersString: allMatters
							? numberWithCommas(allMatters.length)
							: 0,
					},
				},
				(state) => submitBulkMatterPermissionsDialog(state),
				(state) => validateBulkMatterPermissionsDialog(state),
				() => {
					// cancel function
					dispatch({
						type: CLOSE_GLOBAL_EDIT_DIALOG,
					});
				}
			)(dispatch);

			API.post("/bulk/matter/permissions/init", {
				body: { matterIDs: matterIDsToApplyPermissionsTo },
			})
				.then((res) => {
					// close the loading snackbar
					dispatch({
						type: CLOSE_GLOBAL_SNACKBAR,
					});

					const {
						groupsAndUsers,
						allMatchingMatterIDsWithPermissions,
					} = res.mysql;
					const { groups, groupMembership, users } = groupsAndUsers;
					// update the global dialog with the new data
					openGlobalDialog(
						{
							label: `Bulk Update Matter Permissions`,
							canSubmit: false,
							disabledHoverTextForSubmitButton:
								'"confirm" must be typed into the box above',
							hideTextfield: true,
							type: "BulkMatterPermissions",
							submitButtonLabel: "Apply",
							readOnly: false,
							extraCSSClass: "WideEditDialog",
							bulkMatterPermissionsObject: {
								loading: false,
								matterIDsToApplyPermissionsTo,
								availableGroups: groups.map((p) => ({
									value: p.id,
									label: p.name,
									isFixed: p.type === "FIRM_ADMIN",
								})),
								groups,
								groupMembership,
								availableUsers: users.map((user) => {
									// value and label are required by react-select component
									// the other user properties (type and status)
									// are ultimately used by UsersDropDownSelect to
									// allow showing/hiding of disabled users
									return {
										...user,
										value: user.sub,
										label: user.displayName,
									};
								}),
								users,
								allMatchingMatterIDsWithPermissions,
								numFilteredMattersString: numberWithCommas(
									numMattersToApplyPermissionsTo
								),
								numAllMattersString: allMatters
									? numberWithCommas(allMatters.length)
									: 0,
								hasValidActiveFilter:
									numMattersToApplyPermissionsTo <
									allMatters.length,
								clientName,
							},
						},
						(state) => submitBulkMatterPermissionsDialog(state),
						(state) => validateBulkMatterPermissionsDialog(state),
						() => {
							// cancel function
							dispatch({
								type: CLOSE_GLOBAL_EDIT_DIALOG,
							});
						}
					)(dispatch);
				})
				.catch((err) => {
					console.log(err);
					// if there is an error, close the loading global dialog and open an error snackbar
					dispatch({
						type: CLOSE_GLOBAL_EDIT_DIALOG,
					});
					if (isPreventActionOnDeletedResource(err.lxwErrorCode)) {
						// handled in errorActions
						return;
					}
					if (err.lxwErrorCode === 6008) {
						// handled in errorActions
						return;
					}
					dispatch({
						type: OPEN_GLOBAL_SNACKBAR,
						payload: {
							variant: "error",
							message:
								"Unable to process this request. Please ensure your filter includes at least one matter and try again. Contact support if you continue to experience issues.",
						},
					});
				});
		} else {
			console.log("active filter does not include any matters");
			dispatch({
				type: OPEN_GLOBAL_SNACKBAR,
				payload: {
					variant: "error",
					message: "Your filter must include at least one matter",
				},
			});
		}
	};
}
export function getEverythingForEditMatter(matterID) {
	return function (dispatch) {
		var helperPromise = API.get("/matter/editMatterHelper", {
			queryParams: { matterID: matterID },
		});

		dispatch({ type: GET_EVERYTHING_FOR_NEW_EDIT_MATTER_REQUEST });

		helperPromise
			.then((results) => {
				dispatch({
					type: GET_EVERYTHING_FOR_EDIT_MATTER_SUCCESS,
					payload: {
						availableAssignedStaff: results.mysql.Users,
						availableMatterTags: results.mysql.MatterTags,
						availableMatterTypes: results.mysql.MatterTypes,
						availableOfficeBranches: results.mysql.OfficeBranch,
						availableClients: results.mysql.Clients,
						matterDetails: results.mysql.MatterData,
						matterPermissions: results.mysql.MatterPermissions,
						permissionsGroups: results.mysql.PermissionsGroups,
					},
				});
				dispatch({
					type: SET_SUBHEADER_TEXT,
					payload: {
						subheaderText:
							"Editing " + results.mysql.MatterData.name,
					},
				});
			})
			.catch(() => {
				dispatch({
					type: GET_EVERYTHING_FOR_EDIT_MATTER_FAILURE,
				});
				window.globalHistory.push("/");
			});
	};
}
export function unmountNewEditMatter() {
	return function (dispatch) {
		dispatch({
			type: UNMOUNT_NEW_EDIT_MATTER,
		});
	};
}
export function updateMatter(matterID, matterData) {
	const newMatterData = matterDataHelper(matterData);
	return function (dispatch) {
		API.put("/matter", {
			queryParams: { matterID },
			body: { newMatterData: newMatterData },
		})
			.then((results) => {
				const matterState = store.getState().matter;
				window.globalHistory.push(
					matterState.editMatterRedirectLocation
				);
				if (results.mysql?.updateMatterPermissionsDenied === true) {
					// user attempted to add matter permissions but backend claims they don't have the right
					dispatch({
						type: OPEN_GLOBAL_SNACKBAR,
						payload: {
							variant: "warning",
							message:
								"Matter updated, but matter permissions were not applied.",
						},
					});
				}
			})
			.catch((err) => {
				if (isPreventActionOnDeletedResource(err.lxwErrorCode)) {
					// handled in errorActions
					return;
				}
				console.error("Error updating matter", err);
			});
	};
}
export function closeMatter(matterID, reopen) {
	return function (dispatch) {
		API.post("/matter/close", {
			body: { matterID, reopen },
		})
			.then((response) => {
				console.log("matter closed", response);
				dispatch({
					type: reopen
						? "REOPEN_MATTER_SUCCESS"
						: "CLOSE_MATTER_SUCCESS",
					payload: { closedDate: response.mysql.closedDate },
				});
			})
			.catch((err) => {
				if (isPreventActionOnDeletedResource(err.lxwErrorCode)) {
					// handled in errorActions
					return;
				}
				console.error("Error closing matter", err);
			});
	};
}
export function getEverythingForNewMatter() {
	return function (dispatch) {
		dispatch({ type: GET_EVERYTHING_FOR_NEW_EDIT_MATTER_REQUEST });
		API.get("/matter/newMatterHelper")
			.then((results) => {
				dispatch({
					type: GET_EVERYTHING_FOR_NEW_MATTER_SUCCESS,
					payload: {
						availableAssignedStaff: results.mysql.Users,
						availableMatterTags: results.mysql.MatterTags,
						availableMatterTypes: results.mysql.MatterTypes,
						availableOfficeBranches: results.mysql.OfficeBranch,
						availableClients: results.mysql.Clients,
						matterPermissions: results.mysql.MatterPermissions,
						permissionsGroups: results.mysql.PermissionsGroups,
					},
				});
			})
			.catch(() => {
				dispatch({
					type: GET_EVERYTHING_FOR_NEW_MATTER_FAILURE,
				});
			});
	};
}
// `quiet` skips the _REQUEST/_FAILURE dispatches — those are what
// globalReducer's blanket "any _REQUEST shows the full-page loading
// blocker" convention keys off of. The AI Add Context Browse tab has its
// own inline spinner for this exact fetch and doesn't want that full-page
// blocker layering on top of it, but still wants the _SUCCESS payload to
// land in the shared state.matter.mattersList like every other caller.
export function fetchMattersList(filter, { quiet } = {}) {
	return function (dispatch) {
		if (!quiet) dispatch({ type: FETCH_MATTERS_LIST_REQUEST });
		const clientID = filter.clientID;
		// identifies which filtered list this is, since they all share mattersList
		const listKey = `${clientID}:${!!filter.includeFirmDocs}`;
		API.get(
			"/matters",
			{
				queryParams: {
					clientID,
					includeFirmDocs: filter.includeFirmDocs,
				},
			},
			// the matter browse modal (quiet) shouldn't pop a rate limit snackbar
			{ suppressRateLimitSnackbar: !!quiet }
		)
			.then((results) => {
				dispatch({
					type: FETCH_MATTERS_LIST_SUCCESS,
					payload: results.mysql,
					listKey,
				});
				if (clientID) {
					setGlobalSearchMatterIDs(
						results.mysql
							.filter(
								(m) =>
									m.matterLifecycleStatus ===
									NORMAL_LIFECYCLE_STATUS
							)
							.map((x) => x.id)
					)(dispatch);
				}
			})
			.catch((err) => {
				if (!quiet) {
					dispatch({
						type: FETCH_MATTERS_LIST_FAILURE,
						payload: { rateLimited: isRateLimitError(err) },
						listKey,
					});
				}
			});
	};
}
export function fetchMatterDetail(matterID) {
	return function (dispatch) {
		dispatch({ type: FETCH_MATTER_DETAIL_REQUEST });
		API.get("/matter", {
			queryParams: { matterID: matterID },
		})
			.then((result) => {
				showMatterDetails(result.mysql[0])(dispatch);
			})
			.catch(() => {
				window.globalHistory.push("/");
				dispatch({
					type: FETCH_MATTER_DETAIL_FAILURE,
				});
			});
	};
}
export function showMatterDetails(matterDetails) {
	return function (dispatch) {
		dispatch({
			type: FETCH_MATTER_DETAIL_SUCCESS,
			payload: {
				matterDetails: matterDetails,
			},
		});
		dispatch({
			type: SET_SUBHEADER_TEXT,
			payload: {
				subheaderText: matterDetails.name,
				subheaderChips: matterDetails.tags.length
					? matterDetails.tags.map((tag, index) => {
							return { label: tag.tagName, key: index };
						})
					: [],
			},
		});
		dispatch(
			updateRecentlyViewedMatters(
				matterDetails.id,
				matterDetails.matterLifecycleStatus
			)
		);
	};
}

// previousMatterLifecycleStatus is the matter's status before this change, the undo link moves it back there
export function setMatterLifecycleStatus({
	matterLifecycleStatus,
	previousMatterLifecycleStatus,
	matterID,
	callback,
}) {
	return function (dispatch) {
		const isMovingToTrash =
			matterLifecycleStatus === TRASH_LIFECYCLE_STATUS;
		const isMovingToArchive =
			matterLifecycleStatus === ARCHIVE_LIFECYCLE_STATUS;
		API.post(
			"/matter/setLifecycleStatus",
			{ body: { matterLifecycleStatus, matterID } },
			{ dontRedirectToHomepage: true }
		)
			.then(() => {
				if (callback && typeof callback === "function") {
					callback();
				}
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "success",
						message: (
							<div>
								{isMovingToTrash
									? "Moved Matter to Trash Bin"
									: isMovingToArchive
										? "Moved Matter to Archive"
										: "Restored Matter"}{" "}
								successfully. Click{" "}
								<a
									className="lw-internal-action-link white"
									onClick={() =>
										setMatterLifecycleStatus({
											matterLifecycleStatus:
												previousMatterLifecycleStatus,
											previousMatterLifecycleStatus:
												matterLifecycleStatus,
											matterID,
											callback,
										})(dispatch)
									}
								>
									Here
								</a>{" "}
								to undo
							</div>
						),
					},
				});
			})
			.catch((err) => {
				if (callback && typeof callback === "function") {
					callback();
				}
				console.error(err);
				if (isPreventArchiveAction(err?.lxwError?.code)) {
					console.log(err?.lxwErrorData?.userMessage);
					dispatch({
						type: OPEN_GLOBAL_SNACKBAR,
						payload: {
							variant: "error",
							message: (
								<div>
									{err?.lxwError?.userMessage ||
										err?.lxwErrorData?.userMessage}
								</div>
							),
						},
					});
				} else {
					dispatch({
						type: OPEN_GLOBAL_SNACKBAR,
						payload: {
							variant: "error",
							message: (
								<div>
									Failed to{" "}
									{isMovingToTrash
										? "move Matter to Trash Bin"
										: isMovingToArchive
											? "Archive Matter"
											: "restore Matter"}
									. Please try again.
								</div>
							),
						},
					});
				}
			});
	};
}

export function deleteRestoreMultipleMattersFromTrashPage({
	matterIDs,
	isDeleted,
}) {
	return function (dispatch) {
		let matterOrMatters = matterIDs.length > 1 ? "Matters" : "Matter";
		API.post(
			"/matters/setLifecycleStatus",
			{
				body: {
					matterIDs,
					matterLifecycleStatus: isDeleted
						? TRASH_LIFECYCLE_STATUS
						: NORMAL_LIFECYCLE_STATUS,
				},
			},
			{ dontRedirectToHomepage: true }
		)
			.then(() => {
				dispatch({ type: UNSELECT_ALL });
				listTrash({ trashPageContext: "matters" })(dispatch);
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "success",
						message: (
							<div>
								{isDeleted
									? `Moved ${matterOrMatters} to Trash Bin`
									: `Restored ${matterOrMatters} from Trash Bin`}{" "}
								successfully. Click{" "}
								<a
									className="lw-internal-action-link white"
									onClick={() =>
										deleteRestoreMultipleMattersFromTrashPage(
											{
												matterIDs,
												isDeleted: !isDeleted,
											}
										)(dispatch)
									}
								>
									Here
								</a>{" "}
								to undo
							</div>
						),
					},
				});
			})
			.catch(() => {
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "error",
						message: (
							<div>
								Failed to{" "}
								{isDeleted
									? `move ${matterOrMatters} to Trash Bin`
									: `restore ${matterOrMatters} from Trash Bin`}
								. Please try again.
							</div>
						),
					},
				});
			});
	};
}
export function exportMatter(matterID) {
	return function (dispatch) {
		API.post("/matter/export", { body: { matterID } }).then((res) => {
			if (res?.mysql?.jobID) {
				var jobID = res.mysql.jobID;
				beginBulkDownloadJob(jobID, true)(dispatch);
			}
		});
	};
}
export function setEditMatterRedirectLocation(url) {
	return function (dispatch) {
		dispatch({ type: SET_EDIT_MATTER_REDIRECT_LOCATION, payload: { url } });
	};
}
